export const supportedCountries = ["uk", "de", "us", "at", "nl", "ca"];
export const supportedCountriesLocale = {
  at: "de",
  nl: "nl",
  uk: "en",
  de: "de",
  us: "en",
  ca: "en",
};
export const supportedIsoCountries = {
  uk: "GB",
  gb: "GB",
  de: "DE",
  us: "US",
  at: "AT",
  nl: "NL",
  ca: "CA",
};
export const supportedCountriesPrefixes = {
  uk: "+44",
  de: "+49",
  us: "+1",
  at: "+43",
  nl: "+31",
  ca: "+1",
};
export const sitesId = {
  uk: "FHUK",
  de: "FHDE",
  us: "FHUS",
  at: "FHAT",
  nl: "FHNL",
  ca: "FHCA",
};
export const captchaLangs = {
  uk: "en-GB",
  de: "de",
  us: "en",
  nl: "nl",
  at: "de",
  ca: "en",
};
export const countryCodes = {
  ar: "ar",
  at: "at",
  be: "be",
  bg: "bg",
  br: "br",
  ca: "ca",
  cz: "cz",
  de: "de",
  es: "es",
  fr: "fr",
  gr: "gr",
  hu: "hu",
  it: "it",
  jp: "jp",
  mx: "mx",
  nl: "nl",
  pl: "pl",
  pt: "pt",
  sk: "sk",
  ru: "ru",
  si: "si",
  uk: "uk",
  us: "us",
};

export const zipCodesExcluded = {
  fr: ["971", "972", "973", "976", "974", "987", "988", "986", "975"],
  es: ["510", "520"],
};

export const paymentMethods = {
  openInvoce: "OPEN_INVOICE",
  creditCard: "CREDIT_CARD",
};
export const productIdNative = {
  pl: [
    "3684",
    "3634",
    "3641",
    "3643",
    "3584",
    "3677",
    "3691",
    "3681",
    "3658",
    "3702",
  ],
};
